import { Component, Input } from '@angular/core';
import { IoniconsOutline } from '@pt/pt-models';
import { of } from 'rxjs';
import { DialogService } from '../../services/dialog.service';

@Component({
  selector: 'pt-input-label',
  template: `
    <ng-container *ngIf="inputId; then  WITH_ID; else NO_ID"></ng-container>

    <ng-template #popContent>
      <div style="font-size: 12px;" [innerHTML]="help"></div>
    </ng-template>

    <ng-template #popTitle>Fancy <b>content!!</b></ng-template>
    <ng-template #WITH_ID>
      <label class="form-label d-flex flex-row " style="width: max-content;" [ngClass]="{'fw-bold': fontWeightBold}" [htmlFor]="inputId">
        <span [innerHTML]="label"></span>
        <span class="text-danger" *ngIf="isRequired && showRequiredSign"> * </span>

        <ng-container *ngIf="help">
          <ng-container *ngIf="helpType === 'DIALOG'">
            <pt-icon
              [key]='IconInfoCircle'
              [size]='14'
              class="widget-info-icon-color d-flex cursor-pointer"
              (click)="openHelp(help)">
            </pt-icon>
          </ng-container>
          <ng-container *ngIf="helpType === 'TOOLTIP'">
            <pt-icon
              [key]='IconInfoCircle'
              [size]='14'
              class="widget-info-icon-color d-flex"
              container="body"
              [triggers]="'hover'"
              [ngbPopover]="popContent">
            </pt-icon>
          </ng-container>
        </ng-container>

        <ng-content></ng-content>
      </label>
    </ng-template>

    <ng-template #NO_ID>
      <label class="form-label d-flex flex-row" style="width: max-content;" [ngClass]="{'fw-bold': fontWeightBold}">
        <span [innerHTML]="label"></span>
        <span class="text-danger" *ngIf="isRequired && showRequiredSign"> * </span>

        <ng-container *ngIf="help">
          <ng-container *ngIf="helpType === 'DIALOG'">
            <pt-icon
              [key]='IconInfoCircle'
              [size]='14'
              class="widget-info-icon-color d-flex cursor-pointer"
              (click)="openHelp(help)">
            </pt-icon>
          </ng-container>
          <ng-container *ngIf="helpType === 'TOOLTIP'">
            <pt-icon
              [key]='IconInfoCircle'
              [size]='14'
              class="widget-info-icon-color d-flex"
              container="body"
              [triggers]="'hover'"
              [ngbPopover]="popContent">
            </pt-icon>
          </ng-container>
        </ng-container>


        <ng-content></ng-content>
      </label>
    </ng-template>

  `

})
export class InputLabelComponent {

  @Input() inputId?: string;
  @Input() label: string;
  @Input() help?: string;
  @Input() helpType: 'DIALOG' | 'TOOLTIP' = 'TOOLTIP';
  @Input() fontWeightBold = false; // default false
  @Input() isRequired: boolean;
  @Input() showRequiredSign = true;
  IconInfoCircle = IoniconsOutline.infoCircle;

  constructor(private dialogService: DialogService) {
  }

  openHelp(help: string) {
    this.dialogService.runHtmlHelp(of(help));
  }
}
